import { FunctionComponent } from "react";
import styles from "./ProjectDocumentModal.module.css";
import { IoMdDocument } from "react-icons/io";
import { uploadProjectResources } from "../../../Services/resources";
import { connect, useDispatch } from "react-redux";
import { themeColors } from "../../theme";
import "../../../theme-vars.css";
import { useMediaQuery, useTheme } from "@mui/material";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";
import Modal, { Styles } from "react-modal";
import StyledCancelButton from "../../Buttons/StyledCancelButton";

/* ----------------------------------------
   Props Definition
---------------------------------------- */
type props = {
  open: boolean;                     // Controls modal visibility
  close: () => void;                 // Function to close modal
  title: string;                     // Title of the modal
  setLoad: (loading: boolean) => void; // Sets loading state in parent
  projectData: any;                  // Project details for upload mapping
  type: string;                      // Upload type: "images" or "documents"
  theme: any;                        // Light / dark theme flag
};

const ProjectDocumentModal: FunctionComponent<props> = ({
  open,
  close,
  title,
  setLoad,
  projectData,
  type,
  theme
}) => {
  const dispatcher = useDispatch();
  /** MUI theme hook for responsive styling */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  /* ----------------------------------------
     Upload Handler (Drag & Drop + File Input)
     - Extracts file name from input
     - Calls Firebase/Backend upload function
     - Closes modal + toggles loading state
  ---------------------------------------- */
  const upload = async (file: any) => {
    let name: any = document.getElementById('file-input')
    let nameList = name.value.split("\\")
    let fileName = nameList[nameList.length - 1]
    close();
    setLoad(true);
    await uploadProjectResources(
      file[0],
      projectData,
      type,
      fileName,
      dispatcher
    );
    setLoad(false);

  };

  /**
   * React Modal Styling
   */
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "10px 20px",
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      margin: "auto",
      inset: "auto",
    },
  };

  return (
    <>
      {/* Background Blur */}
      <Modal
        isOpen={open}
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={modalStyle}
        ariaHideApp={false}
      >
        <div className={styles.child}>
          {/* MODAL TITLE */}
          <h5
            style={{
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-large)",
              paddingTop: isMobile ? "unset" : "15px"
            }}
          >
            {/* Modal Title */}
            {title}
          </h5>

          {/* Drag & Drop Upload Box */}
          <div
            className={styles.dragBox}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onDrop={(e) => {
              e.preventDefault();
              upload(e.dataTransfer.files);
            }}
          >
            <IoMdDocument size={80} color={"#808080"} />
            <p>Drag And Drop</p>
          </div>

          {/* ACTION BUTTONS SECTION */}
          <div className={styles.selectBox}>
            <div style={{ marginRight: 8 }}>
              <StyledCancelButton onClick={close}>Cancel</StyledCancelButton>
            </div>

            {/* FILE UPLOAD BUTTON */}
            <div>
              <input
                id="file-input"
                className={styles.select}
                type="file"
                accept={type === "images" ? ".png,.jpeg,.jpg" : ".pdf,.png,.jpg,.png"}
                onChange={(e: any) => upload(e.target.files)}
              />
              <StyledSubmitButton
                onClick={() => document.getElementById("file-input")?.click()}
              >
                Upload File
              </StyledSubmitButton>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

/* ----------------------------------------
   Redux State Mapping
---------------------------------------- */
const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ProjectDocumentModal);


